import { render, staticRenderFns } from "./rssfeed.vue?vue&type=template&id=4a299183"
import script from "./rssfeed.vue?vue&type=script&lang=js"
export * from "./rssfeed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports